// Ventures accordion with smooth open/close

export const initAccordion = () => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const items = Array.from(document.querySelectorAll('.witem'));
  if (!items.length) return;

  function panelOf(it) {
    return it.querySelector('.wpanel');
  }

  function setOpen(it, open) {
    const panel = panelOf(it);
    const row = it.querySelector('.wrow');
    const inner = it.querySelector('.wpanel-in');

    if (open) {
      it.classList.add('open');
      row.setAttribute('aria-expanded', 'true');
      if (reduce) {
        panel.style.height = 'auto';
        return;
      }
      const target = inner.offsetHeight;
      panel.style.height = target + 'px';
      const done = e => {
        if (e.propertyName === 'height') {
          panel.style.height = 'auto';
          panel.removeEventListener('transitionend', done);
        }
      };
      panel.addEventListener('transitionend', done);
    } else {
      it.classList.remove('open');
      row.setAttribute('aria-expanded', 'false');
      if (reduce) {
        panel.style.height = '0px';
        return;
      }
      panel.style.height = panel.offsetHeight + 'px';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.style.height = '0px';
        });
      });
    }
  }

  if (!reduce) {
    items.forEach(it => {
      panelOf(it).style.transition = 'height .5s cubic-bezier(.16,.84,.36,1)';
    });
  }

  function toggle(it, forceOpen) {
    const isOpen = it.classList.contains('open');
    if (forceOpen && isOpen) {
      if (window.__ventureHighlight)
        window.__ventureHighlight(it.getAttribute('data-v'), true);
      return;
    }
    items.forEach(other => {
      if (other !== it && other.classList.contains('open'))
        setOpen(other, false);
    });
    const willOpen = forceOpen ? true : !isOpen;
    setOpen(it, willOpen);
    if (window.__ventureHighlight) {
      if (willOpen) {
        window.__ventureHighlight(it.getAttribute('data-v'), true);
      } else {
        window.__ventureHighlight(null, false);
      }
    }
  }

  window.__ventureToggle = toggle;

  items.forEach(it => {
    const row = it.querySelector('.wrow');
    row.addEventListener('click', () => toggle(it));
    row.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle(it);
      }
    });
  });
};
